import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Import all controllers (both .js and .rb - Vite transforms .rb on the fly)
const controllers = import.meta.glob([
  './*_controller.js',
  './*_controller.rb'
], { eager: true });

for (const [path, module] of Object.entries(controllers)) {
  // Extract controller name: ./hello_controller.js -> hello
  const match = path.match(/\.\/(.+)_controller/);
  if (match) {
    const identifier = match[1].replace(/_/g, '-');
    application.register(identifier, module.default);
  }
}

export { application };
